import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'
import { url } from '../../../configlink';

const QRSignupForm = ({page, handleNextPage}) => {

     const [formData, setFormData] = useState({
        name: "",
        company: '',
        pi: '',
        email: "",
        notes: '',
        // promo: false,
        // raffle: false,
        // ticket: '',
      });

        const [errors, setErrors] = useState({});
        const [buttonColor, setButtonColor] = useState(false)

      const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
          ...formData,
          [name]: value,
        });

        setErrors({
          ...errors,
          [name]: "",
        });
        
      };

      
      
      let genericEmailDomains = [
        "@gmail",
        "@yahoo",
        "@outlook",
        "@icloud",
        "@hotmail",
        "@comcast"
      ];

      // "@ymail.com",
      // "@rocketmail.com",
      // "@live.com",
      // "@msn.com",
      // "@me.com",
      // "@mac.com",
      // "@aol.com",
      // "@zoho.com",
      // "@protonmail.com",
      // "@pm.me",
      // "@gmx.com",
      // "@gmx.net",
      // "@mail.com",
      // "@yandex.com",
      // "@yandex.ru"


      const validate = () => {
        const newErrors = {};
        if (!formData.email) {
          newErrors.email = "Please enter email address";
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)) {
          newErrors.email = "Please enter a valid email address";
        } else if(genericEmailDomains.some(domain => formData.email.toLowerCase().includes(domain))){
          newErrors.email = "Please use your organization email";
        }
    
        if (!formData.name) newErrors.name = "Please enter full name";
        if (!formData.company) newErrors.company = "Please enter company/institution";
        // if (formData.raffle && !formData.ticket) newErrors.ticket = "Please enter ticket number";

        // let regEx = new RegExp(/^\+?1?\s*(\(\d{3}\)|\d{3})[-\s]?\d{3}[-\s]?\d{4}$/)
        // if (!formData.phoneNumber) {
        //   newErrors.phoneNumber = "Please enter phone number";
        // } else if (!regEx.test(formData.phoneNumber)) {
        //   newErrors.phoneNumber = "Please enter a valid phone number";
        // }
          
        return newErrors;
      };

      const handleSubmit = () => {
        const validationErrors = validate();
        // console.log(validationErrors);
        if (Object.keys(validationErrors).length > 0) {
          setErrors(validationErrors);
        } else {
          setButtonColor(true)

          // handleNextPage()

    
          let data = {
            name: formData.name,
            company: formData.company,
            pi: formData.pi,
            email: formData.email,
            notes: formData.notes,
            // promo: formData.promo === true ? 'Yes': 'No',
            // raffle: formData.raffle === true ? 'Yes': 'No',
            // ticket: formData.ticket,
            date: new Date().toLocaleDateString()
          }
    
          // console.log(data);
    
          try {
            fetch(`${url}/api/auth/acgtQR`, {
              method:"POST",
              credentials: 'include',
              headers:{
                'Content-Type':'application/json'
              },
              body: JSON.stringify(data)
            })
            .then(res => res.json())
            .then(data => {
              if(data.message === 'success'){
                
                handleNextPage()
                //reset
                setFormData({
                  name: "",
                  company: '',
                  pi: '',
                  email: "",
                  notes: '',
                  // promo: false,
                  // raffle: false,
                  // ticket: '',
                });
              }

              setButtonColor(false)
            })
            .catch(err => {
              setButtonColor(false)
              console.error(err)
            }) 
            
          } catch (error) {
            setButtonColor(false)
            console.error(error);
            
          }      
        }
      };


  return (
    <div className='flex flex-col items-center'>
            <p className='mt-4 text-3xl text-[var(--color-primary-purple)] font-bold text-center'>Welcome to ACGT</p>
            
            <div className='mt-4 w-full px-4 sm:p-8 flex flex-col justify-center items-center max-w-[800px]'>
                <div className='w-full sm:w-[90%] xl:w-[80%] sm:gap-[30px] xl:gap-[50px] flex flex-col  justify-between items-center sm:items-start sm:px-[0px]'>
                    <div className='flex flex-col h-full w-full gap-[10px]'>
                    <div className='flex flex-col'>
                            <label className='text-lg text-[var(--color-primary-purple)] font-black'>
                            Name <span className='text-red-500 font-normal text-2xl'>*</span>
                            </label>
                            <input
                            type='text'
                            placeholder='Enter Full Name'
                            name='name'
                            value={formData.name}
                            onChange={handleChange}
                            className='border-2 border-[var(--color-primary-purple)] rounded-sm px-3 py-1 my-2 text-[var(--color-primary-gray)] h-10 focus:outline-none'
                            />
                            {errors.name && (
                            <span className='text-[14px] text-red-500 font-bold relative top-[-8px]'>
                                {errors.name}
                            </span>
                            )}
                        </div>
                        <div className='flex flex-col'>
                            <label className='text-lg text-[var(--color-primary-purple)] font-black'>
                            Company/Institution <span className='text-red-500 font-normal text-2xl'>*</span>
                            </label>
                            <input
                            type='text'
                            placeholder='Enter Company/Institution'
                            name='company'
                            value={formData.company}
                            onChange={handleChange}
                            className='border-2 border-[var(--color-primary-purple)] rounded-sm px-3 py-1 my-2 text-[var(--color-primary-gray)] h-10 focus:outline-none'
                            />
                            {errors.company && (
                            <span className='text-[14px] text-red-500 font-bold relative top-[-8px]'>
                                {errors.company}
                            </span>
                            )}
                        </div>
                        <div className='flex flex-col'>
                            <label className='text-lg text-[var(--color-primary-purple)] font-black'>
                            Principal Investigator <span className='text-red-500 font-normal text-2xl'></span>
                            </label>
                            <input
                            type='text'
                            // maxLength={10}
                            placeholder='Enter Principal Investigator'
                            name='pi'
                            value={formData.pi}
                            onChange={(event) => {
                                setErrors({ ...errors, pi: "" });
                                // event.target.value = event.target.value.replace(/\D/g, "");
                                setFormData({
                                ...formData,
                                pi: event.target.value,
                                });
                            }}
                            className='border-2 border-[var(--color-primary-purple)] rounded-sm px-3 py-1 my-2 text-[var(--color-primary-gray)] h-10 focus:outline-none'
                            />
                            {/* {errors.pi && (
                            <span className='text-[14px] text-red-500 font-bold relative top-[-8px]'>
                                {errors.pi}
                            </span>
                            )} */}
                        </div>
                        <div className='flex flex-col'>
                            <label className='text-lg text-[var(--color-primary-purple)] font-black'>
                              Email <span className='text-red-500 font-normal text-2xl'>*</span>
                            </label>
                            <input
                            type='text'
                            placeholder='Enter Email'
                            name='email'
                            value={formData.email}
                            onChange={handleChange}
                            className='border-2 border-[var(--color-primary-purple)] rounded-sm px-3 py-1 my-2 text-[var(--color-primary-gray)] h-10 w-full focus:outline-none'
                            />
                            {errors.email && (
                            <span className='text-[14px] text-red-500 font-bold relative top-[-8px]'>
                                {errors.email}
                            </span>
                            )}
                        </div>
                        <div className='flex flex-col'>
                            <label className='text-lg text-[var(--color-primary-purple)] font-black'>
                            Notes
                            </label>
                            <textarea
                            type='text'
                            rows={4}
                            // maxLength={10}
                            placeholder='Enter Notes'
                            name='notes'
                            value={formData.notes}
                            onChange={(event) => {
                                setErrors({ ...errors, notes: "" });
                                // event.target.value = event.target.value.replace(/\D/g, "");
                                setFormData({
                                ...formData,
                                notes: event.target.value,
                                });
                            }}
                            className='border-2 border-[var(--color-primary-purple)] rounded-sm px-3 py-2 my-2 text-[var(--color-primary-gray)] focus:outline-none'
                            />
                            {errors.notes && (
                            <span className='text-[14px] text-red-500 font-bold relative top-[-8px]'>
                                {errors.notes}
                            </span>
                            )}
                        </div>
                        {/* <div className="flex items-start mb-2">
                          <input 
                            type="checkbox" 
                            value={formData.promo}
                            checked={formData.promo === true}
                            onChange={() => {                              
                              setFormData({...formData, promo:!formData.promo})
                            }}
                            className='w-8 h-8 border-2 border-[var(--color-primary-purple)]'
                          />
                          <p className='ml-4'>Yes! Subscribe me to ACGT promotional emails, news and events.</p>
                        </div> */}

                        {/* previous one  */}
                        {/* <div className="flex items-start mb-2">
                          <div>
                            <input 
                              type="checkbox" 
                              value={formData.raffle}
                              checked={formData.raffle === true}
                              onChange={() => {                              
                                if(formData.raffle === true){
                                  setFormData({...formData, raffle: false, ticket: ''})
                                }
                                else{
                                  setFormData({...formData, raffle:!formData.raffle, ticket: Math.floor(10000000 + Math.random() * 90000000)})
                                }
                              }}
                              className='w-5 h-5 mt-[4px] border-2 border-[var(--color-primary-purple)]'
                            />
                          </div>
                          <p className='ml-4'>I wish to enter a raffle for promotional items or discounts and hereby subscribe to the ACGT e-newsletter.</p>
                        </div>
                        {formData.raffle === true && 
                          <div className='flex flex-col'>
                              <label className='text-lg text-[var(--color-primary-purple)] font-black'>
                              Raffle Ticket Number <span className='text-red-500 font-normal text-2xl'>*</span>
                              </label>
                              <input
                              type='text'
                              placeholder='Your Raffle Ticket Number'
                              name='ticket'
                              disabled
                              value={formData.ticket}
                              onChange={(event) => {
                                  setErrors({ ...errors, ticket: "" });
                                  setFormData({
                                  ...formData,
                                  ticket: event.target.value,
                                  });
                              }}
                              className='border-2 border-[var(--color-primary-purple)] rounded-sm px-3 py-1 my-2 text-[var(--color-primary-gray)] h-10 focus:outline-none'
                              />
                              {errors.ticket && (
                              <span className='text-[14px] text-red-500 font-bold relative top-[-8px]'>
                                  {errors.ticket}
                              </span>
                              )}
                          </div>
                        } */}
                      
                        {/* <div className='flex flex-col'>
                            <label className='text-lg text-[var(--color-primary-purple)] font-black'>Address</label>
                            <input
                            type='text'
                            placeholder='Enter Address'
                            name='street'
                            value={formData.street}
                            onChange={handleChange}
                            className='border-2 border-[var(--color-primary-purple)] rounded-sm px-3 py-1 my-2 text-[var(--color-primary-gray)] h-10 focus:outline-none'
                            />
                            {errors.street && (
                            <span className='text-[14px] text-red-500 font-bold relative top-[-8px]'>
                                {errors.street}
                            </span>
                            )}
                        </div>
                        <div className='flex flex-col sm:flex-row flex-wrap justify-between'>
                            <div className='flex flex-col'>
                            <label className='text-lg text-[var(--color-primary-purple)] font-black'>City</label>
                            <input
                                type='text'
                                placeholder='Enter City'
                                name='city'
                                value={formData.city}
                                onChange={handleChange}
                                className='border-2 border-[var(--color-primary-purple)] rounded-sm px-3 py-1 my-2 text-[var(--color-primary-gray)] h-10 w-full sm:w-[200px] focus:outline-none'
                            />
                            {errors.city && (
                                <span className='text-[14px] text-red-500 font-bold relative top-[-8px]'>
                                {errors.city}
                                </span>
                            )}
                            </div>
                            <div className='flex flex-col relative'>
                            <label className='text-lg text-[var(--color-primary-purple)] font-black'>State</label>
                            <div className='w-52 border-2 border-[var(--color-primary-purple)] rounded-sm h-10 my-2 '>
                                    <FormDropdown
                                    options={states}
                                    onSelect={(e) => {
                                        setErrors({
                                        ...errors,
                                        state: "",
                                        });              

                                        setFormData({
                                        ...formData,
                                        state: e,
                                        });
                                    
                                    }}
                                    selectedOption={formData.state}
                                    type={2}
                                    noPadding={true}
                                    />
                            </div>
                            
                            {errors.state && (
                                <span className='text-[14px] text-red-500 font-bold relative top-[-8px]'>
                                {errors.state}
                                </span>
                            )}
                            </div>
                            <div className='flex flex-col'>
                            <label className='text-lg text-[var(--color-primary-purple)] font-black'>
                                Zip Code
                            </label>
                            <input
                                type='text'
                                placeholder='Enter Zip'
                                name='zip'
                                value={formData.zip}
                                onChange={(event) => {
                                event.target.value = event.target.value.replace(/\D/g, "");

                                if (event.target.value.length > 5) {
                                event.target.value = event.target.value.slice(0, 5);
                                }

                                setErrors({...errors, zip:''})

                                setFormData({
                                ...formData,
                                zip: event.target.value
                                })
                                }}
                                className='border-2 border-[var(--color-primary-purple)] rounded-sm px-3 py-1 my-2 text-[var(--color-primary-gray)] h-10 w-full sm:w-[150px] focus:outline-none'
                            />
                            {errors.zip && (
                                <span className='text-[14px] text-red-500 font-bold relative top-[-8px]'>
                                {errors.zip}
                                </span>
                            )}
                            </div>
                        </div> */}
                              
                        <button
                            onClick={handleSubmit}
                            className={`px-4 py-2 rounded-3xl font-bold ${buttonColor? 'bg-[#58595b] pointer-events-none' : 'bg-[var(--color-primary-purple)]'} w-[150px] sm:w-[200px] self-center text-white uppercase mb-4 mt-6`}
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </div>
    
    </div>
  )
}

export default QRSignupForm